import { SidenavItemInterface } from "src/app/shared/side-nav/interfaces/side-nav-items.interface";
import { EAdminPermission } from "src/app/core/enums/admin-permission.enum";

export const adminSideNavConfig: SidenavItemInterface[] = [
  {
    id: 'admin_users',
    label: 'adminUsers',
    routerLink: '/admin-users',
    permissions: EAdminPermission.LIST_ADMINS,
  },
  {
    id: 'admin_roles',
    label: 'adminRoles',
    routerLink: '/admin-roles',
    permissions: EAdminPermission.LIST_ROLES,
  },
  {
    id: 'interest-rate-bracket',
    label: 'interestRateBracket',
    routerLink: '/interest-rate-bracket',
    permissions: EAdminPermission.VIEW_INTEREST_RATE_BRACKET,
  },
  {
    id: 'transaction-categories',
    label: 'transactionCategories',
    routerLink: '/transaction-categories',
    permissions: EAdminPermission.LIST_TRANSACTION_CATEGORIES,
  },
  {
    id: 'prices',
    label: 'prices',
    routerLink: '/prices',
    permissions: EAdminPermission.VIEW_PRICES,
  },
];
